import { Box } from '@mui/material';
import HeaderWithActions, {
  CustomButtonProps,
} from 'lib/designSystem/HeaderWithActions';
import TableWithPagination from 'lib/designSystem/TableWithPagination';
import { formatMoney } from 'lib/functions/utils';
import { Warranty } from 'lib/types/models';
import { Pagination } from 'lib/types/shared';
import React from 'react';

interface WarrantiesTableProps {
  warranties: Warranty[];
  setWarranties: (warranties: Warranty[]) => void;
  handleOpenWarrantyDetail: (warrantyId: number) => void;
  pagination: Pagination;
  setPagination: (pagination: Pagination) => void;
  fetchWarranties: () => Promise<void>;
  setIsLoading: (isLoading: boolean) => void;
  showBusinessName?: boolean;
  buttons: CustomButtonProps[];
  guaranteeTypeFilter?: React.ReactNode;
}

const WarrantiesTable = ({
  warranties,
  setWarranties,
  handleOpenWarrantyDetail,
  pagination,
  setPagination,
  fetchWarranties,
  setIsLoading,
  showBusinessName = true,
  buttons,
  guaranteeTypeFilter,
}: WarrantiesTableProps) => {
  const tableHeaders = [
    {
      label: 'ID',
      key: 'id',
      type: 'numeric-id',
    },
    {
      label: 'Tipo',
      key: 'translatedType',
    },
    ...(showBusinessName
      ? [
          {
            label: 'Cliente',
            key: 'businessName',
          },
        ]
      : []),
    {
      label: 'Estado',
      key: 'translatedStatus',
      type: 'status-chip',
    },
    {
      label: 'Monto Cotizado',
      key: 'quotedAmount',
      type: 'money',
    },
    {
      label: 'Moneda',
      key: 'quotedCurrency',
    },
    {
      label: 'Costo de emisión',
      key: 'premium',
      customComponent: (value: number) => `${formatMoney(value)} CLP`,
    },
    {
      label: 'Fecha Cotización',
      key: 'quoteDate',
      type: 'date',
    },
    {
      label: 'Fecha Inicio',
      key: 'startDate',
      type: 'date',
    },
    {
      label: 'Fecha Término',
      key: 'endDate',
      type: 'date',
    },
  ];

  return (
    <Box>
      <HeaderWithActions
        title=""
        variant="body1"
        buttons={buttons}
        customTitle={guaranteeTypeFilter}
      />
      <TableWithPagination
        data={warranties}
        setData={setWarranties}
        dataHeaders={tableHeaders}
        handleClickRow={handleOpenWarrantyDetail}
        showActions
        pagination={pagination}
        setPagination={setPagination}
        searchData={fetchWarranties}
        setLoading={setIsLoading}
        exportToFile="xlsx"
        exportComplete
        lastElement
      />
    </Box>
  );
};

export default WarrantiesTable;
